"use client"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import { colors, mediaQueries, sizes } from "ui"
import CommonTitle from "ui/common/bit/CommonTitle"
import RichTextWrapper from "ui/common/bit/RichTextWrapper"
import { getNonUmbracoUrl, getUmbracoMediaUrl } from "utils"
import { transformProperties } from "utils/simplifyData"
import ButtonWithArrow from "../common/bit/ButtonWithArrow"
import BlockWrapper from "../common/BlockWrapper"

const StyledInsuranceCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.baseDouble};
  background-color: ${colors.white};
  padding: 40px;
  box-shadow: 9.77px -9.77px 36.65px 0px #0f244f14;
  backdrop-filter: blur(41.53205108642578px);
  border-radius: ${sizes.borderRadius};
`
const StyledCardsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${sizes.baseTriple};
  justify-content: center;
  ${mediaQueries.desktopM} {
    grid-template-columns: 582px 582px;
  }
`
const StyledImageWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${sizes.baseDouble};
  ${mediaQueries.desktopM} {
    margin-top: ${sizes.baseSix};
  }
`

type Props = {
  data: any
  id?: string
}

const lobbyHealthAllInsuranceBlock = ({ data, id }: Props) => {
  const title = data.title.value
  const subtitle = data.subtitle.value
  const items = data.itemsList.blocks
  const button = data.button.links[0]

  return (
    <BlockWrapper id={id}>
      <CommonTitle
        title={title}
        mobileTitle={title}
        subtitle={subtitle}
        mobileSubtitle={subtitle}
      />
      <StyledCardsWrapper>
        {items.map((item: any, index: number) => {
          const { icon, title, subtitle, text } = transformProperties(
            item.properties,
          )
          return (
            <StyledInsuranceCard key={`insurance-card-${title}-${index}`}>
              <StyledImageWrapper>
                <Image
                  src={getUmbracoMediaUrl(
                    icon?.mediaItems && icon?.mediaItems[0]?.url,
                  )}
                  alt={title.value}
                  width={52}
                  height={52}
                />
              </StyledImageWrapper>
              <Typography
                variant="h4"
                color={colors.black}
                fontSize={30}
                style={{ textAlign: "center" }}
              >
                {title.value}
              </Typography>
              <Typography variant="body1">{subtitle.value}</Typography>
              <RichTextWrapper
                richText={text.richText}
                mobileParagraphFontSize="13px"
                anchorFontWeight={400}
              />
            </StyledInsuranceCard>
          )
        })}
      </StyledCardsWrapper>
      {button && (
        <ButtonWrapper>
          <ButtonWithArrow href={getNonUmbracoUrl(button.url)}>
            {button.name}
          </ButtonWithArrow>
        </ButtonWrapper>
      )}
    </BlockWrapper>
  )
}

export default lobbyHealthAllInsuranceBlock
